'use client'

import { usePathname } from 'next/navigation'
import { useTranslations } from 'next-intl'

import { useRouter } from '@/shared/i18n'
import { ConfirmDialog } from '@/shared/ui'

type Props = {
  isOpen: boolean
  onOpenChange: (open?: boolean) => void
  path: string | null
}

export const MoveToSignInDialog = ({
  isOpen,
  onOpenChange,
  path: pathProp,
}: Props) => {
  const pathname = usePathname()
  const router = useRouter()

  const t = useTranslations('navigation.sign_in_dialog')

  const handleMoveToLoginConfirm = () => {
    onOpenChange(false)

    const path = pathProp || pathname || ''
    router.push(
      `/sign-in${path ? `?redirect=${encodeURIComponent(path)}` : ''}`,
    )
  }

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={t('title')}
      content={t('content')}
      cancelText={t('button.cancel')}
      confirmText={t('button.confirm')}
      onConfirm={handleMoveToLoginConfirm}
    />
  )
}
